import BasicLayout from "@/layouts/basic-layout";

const meta = {
  auth: false,
  cache: false,
};
export default {
  path: "/home",
  name: "/home",
  redirect: {
    name: "home",
  },
  meta,
  component: BasicLayout,
  children: [
    {
      path: "/home/list",
      name: "homeList",
      meta: {
        ...meta,
        title: "房屋管理",
        cache: true,
      },
      component: () => import("@/pages/home/index.vue"),
    },
    {
      path: "/home/homeDetails",
      name: "homeDetails",
      meta: {
        ...meta,
        title: "新增房屋",
        // cache: true,
      },
      component: () => import("@/pages/home/homeDetails.vue"),
    },
  ],
};
